// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";
export { application };

import AutosubmitController from "./autosubmit_controller";
application.register("autosubmit", AutosubmitController);

import GeocoderSearchController from "./geocoder_search_controller";
application.register("geocoder-search", GeocoderSearchController);

import ModalController from "./modal_controller";
application.register("modal", ModalController);

import RailsNestedForm from "@stimulus-components/rails-nested-form";
application.register("nested-form", RailsNestedForm);

import PasswordVisibilityController from "./password_visibility_controller";
application.register("password-visibility", PasswordVisibilityController);

import PermissionsController from "./permissions_controller";
application.register("permissions", PermissionsController);

import RevealController from "./reveal_controller";
application.register("reveal", RevealController);

import SearchController from "./search_controller";
application.register("search", SearchController);

import Sortable from "@stimulus-components/sortable";
application.register("sortable", Sortable);

import EstablishmentsController from "./establishments_controller";
application.register("establishments", EstablishmentsController);

import BrandStoresController from "./brand_stores_controller";
application.register("brand-stores", BrandStoresController);

import TrixTagController from "./trix_tag_controller";
application.register("trix-tag", TrixTagController);

import ImageGalleryController from "./image_gallery_controller";
application.register("image-gallery", ImageGalleryController);

import AdvancedFiltersController from "./advanced_filters_controller";
application.register("advanced-filters", AdvancedFiltersController);

import ChoicesController from "./choices_controller";
application.register("choices", ChoicesController);

import PerPageController from "./per_page_controller";
application.register("per-page", PerPageController);

import TruncateController from "./truncate_controller";
application.register("truncate", TruncateController);

import LightboxController from "./lightbox_controller";
application.register("lightbox", LightboxController);
